export default __webpack_public_path__ + "father-at-yarisi.svg";